import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Form } from "react-bootstrap";

import { CHECKBOX, RADIO } from "../../../constants/checkType";
import "./styles.scss";

const Check = ({ input, className, type, ...rest }) => {
  let reduxFormProps = {};

  if (input) {
    reduxFormProps = input;

    if (type === CHECKBOX) reduxFormProps.checked = input.value;
  }

  return (
    <Form.Check
      {...reduxFormProps}
      {...rest}
      type={type}
      className={classNames(
        "mydpd-form-check",
        `mydpd-form-${type}`,
        className
      )}
    />
  );
};

Check.propTypes = {
  type: PropTypes.oneOf([CHECKBOX, RADIO]).isRequired,
  className: PropTypes.string,
  input: PropTypes.object,
};

export default Check;
